import { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/auth.store';
import { refreshSession } from './services/api';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ConversionsPage from './pages/ConversionsPage';
import ReportsPage from './pages/ReportsPage';
import ApiDocsPage from './pages/ApiDocsPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { token, clear } = useAuthStore();
  const [recovering, setRecovering] = useState(!token);

  useEffect(() => {
    if (token) { setRecovering(false); return; }
    // The token is memory-only, so a reload always lands here and rebuilds the
    // session from the refresh cookie before anything renders.
    refreshSession().catch(() => { clear(); setRecovering(false); });
  }, [token, clear]);

  if (recovering) return null;
  if (!token) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="conversions" element={<ConversionsPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="api-docs" element={<ApiDocsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
